{
  "Quantity": "Hoeveelheid",
  "Item": "Item",
  "CMEnvironment": "CME's",
  "TelephonyServer": "Telefonieserver",
  "Partitions": "partities",
  "Devices": "Apparaten",
  "Agents": "agenten",
  "ReportingUsers": "Gebruikers in bulk uploaden",
  "NonReportingUsers": "Niet-rapporterende gebruikers",
  "Estate_ButtonHelpLabel": "Helpen?",
  "Estate_ButtonSubmitLabel": "Oke",
  "Estate_ButtonCancelLabel": "Annuleren",
  "Estate_PromptMessage": "Weet u zeker dat u dit venster wilt sluiten? Alle gewijzigde configuraties gaan verloren wanneer ze worden gesloten.",
  "Estate_PromptConfirm": "Ja",
  "Estate_PromptCancel": "Annuleren",
  "NAME": "Estate"
}